import { useState } from "react";
import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { FEEDBACK_CN_FORM } from "@routes/Article/components/Feedback/utils/constants";
import { cn } from "@util/helpers";

type FeedbackCNProps = {
  /** This is the classname of the component. */
  className?: string;
};

/**
 * Feedback button for users to share their feedback on chinese translation
 * https://www.figma.com/design/LHoF60AgvlnXcwv25cns5j/ARTICLE-PAGE--WEB---APP-?node-id=6292-50090&m=dev
 */
const FeedbackCN = ({ className }: FeedbackCNProps): React.ReactElement => {
  const sendDataToGTM = useGTMDispatch();
  const [isThumbsUp, setIsThumbsUp] = useState(false);

  const handleThumbsUp = () => {
    sendDataToGTM({
      event: "custom_event",
      eventCategory: "feedback widget",
      eventAction: "click",
      eventLabel: "thumbs up",
    });

    setIsThumbsUp(true);
  };

  const handleThumbsDown = () => {
    sendDataToGTM({
      event: "custom_event",
      eventCategory: "feedback widget",
      eventAction: "click",
      eventLabel: "thumbs down",
    });
  };

  return (
    <div
      data-testid="feedback-cn-component"
      data-section-name="feedback widget"
      className={cn(
        "track-impression border-l-[3px] border-gray-850 bg-gray-175 p-4 lg:flex lg:flex-row lg:items-center lg:justify-center",
        className
      )}
    >
      <p className="mb-3 text-center lg:mb-0">此翻译对您是否有帮助？</p>

      <div className="ml-auto flex items-center justify-center gap-4">
        {isThumbsUp ? (
          <p className="text-center">感谢您的反馈</p>
        ) : (
          <>
            <ButtonFactory
              buttonType={ButtonType.Secondary}
              icon={<IconFactory type={IconTypeEnum.thumbsUp} size={20} />}
              className="bg-white p-3"
              onClick={handleThumbsUp}
            />

            <ButtonFactory
              buttonType={ButtonType.Link}
              mask={ButtonType.Secondary}
              className="bg-white p-3"
              link={FEEDBACK_CN_FORM}
              onClick={handleThumbsDown}
            >
              <IconFactory type={IconTypeEnum.thumbsDown} size={20} />
            </ButtonFactory>
          </>
        )}
      </div>
    </div>
  );
};

export default FeedbackCN;
